import { Box } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { AuthContext } from '../../../context/AuthProvider';
import { WorkflowContext } from '../../../contexts/WorkflowProvider';
import PageHeaderTable from '../../../reusable-component/PageHeaderTable';
import WorkflowTabs from '../../../reusable-component/WorkflowTabs';
import WorkflowStepper from '../../../components/workflow-steppers/WorkflowStepper';

const WorkflowOnboard = ({ headerTableData, processType, processWorkflowType }) => {
  const { workflow, setWorkflow } = useContext(WorkflowContext);
  const { domainName } = useContext(AuthContext);
  const headerData = {
    firstHeader: 'WORKFLOW',
    secondHeader: 'DOMAIN',
    thirdHeader: 'CLIENT',
    fourthHeader: 'ENGAGEMENT',
    fifthHeader: 'CREATED BY',
    sixthHeader: 'CREATED ON',
    seventhHeader: 'STATUS',
    firstHeaderText: headerTableData?.workflow_name,
    secondHeaderText: headerTableData?.workflow_data.engagement.client.depDomainEntity.domain_name,
    thirdHeaderText: headerTableData?.client_name,
    fourthHeaderText: headerTableData?.engagement_name,
    fifthHeaderText: headerTableData?.created_by,
    sixthHeaderText: headerTableData?.created_at,
    seventhHeaderText: headerTableData?.status,
    workflow: headerTableData?.workflow_data,
    domainName,
    route: `/workflow-${processType}-${processWorkflowType}?processType=${processType}`,
  };

  const handleWorkflowContext = () => {
    setWorkflow(headerData.workflow);
  };

  useEffect(() => {
    handleWorkflowContext();
  }, [headerTableData]);

  return (
    <>
      <Box>
        <PageHeaderTable data={headerData} />
        <Box sx={{ width: '100%', marginTop: 2, marginBottom: 2 }}>
          <WorkflowTabs processType={processType} processWorkflowType={processWorkflowType} />
        </Box>
        <Box>
          <WorkflowStepper />
        </Box>
      </Box>
    </>
  );
};

export default WorkflowOnboard;
